// 角色枚举
export const ROLES = {
  STUDENT: 'STUDENT',           // 学生/家长
  TEACHER: 'TEACHER',           // 校级老师
  SCHOOL_ADMIN: 'SCHOOL_ADMIN', // 校区管理员
  DISTRICT_ADMIN: 'DISTRICT_ADMIN', // 区级管理员
  CITY_ADMIN: 'CITY_ADMIN',     // 市级管理员
  ORGANIZER: 'ORGANIZER'        // 组委会
}

// 认证状态
export const AUTH_STATUS = {
  UN_AUTH: 'UN_AUTH',           // 未认证
  AUTHING: 'AUTHING',           // 认证中
  AUTH_SUCCESS: 'AUTH_SUCCESS', // 认证成功
  AUTH_FAIL: 'AUTH_FAIL'        // 认证失败
}

// 报名状态
export const SIGNUP_STATUS = {
  PENDING: 'PENDING',           // 待报名
  AUDITING: 'AUDITING',         // 审核中
  APPROVED: 'APPROVED',         // 已通过
  REJECTED: 'REJECTED',         // 已拒绝
  CANCELLED: 'CANCELLED'        // 已取消
}

// 材料状态
export const MATERIAL_STATUS = {
  DRAFT: 'DRAFT',               // 草稿
  SUBMITTED: 'SUBMITTED',       // 已提交
  MODIFY: 'MODIFY'              // 需修改
}

// 评审级别
export const REVIEW_LEVEL = {
  SCHOOL: 'SCHOOL',             // 校级
  DISTRICT: 'DISTRICT',         // 区级
  CITY: 'CITY'                  // 市级
}

// 评审状态
export const REVIEW_STATUS = {
  PENDING: 'PENDING',           // 待评审
  PASS: 'PASS',                 // 通过
  FAIL: 'FAIL'                  // 淘汰
}

// 奖项等级
export const AWARD_LEVEL = {
  FIRST: 'FIRST',               // 一等奖
  SECOND: 'SECOND',             // 二等奖
  THIRD: 'THIRD',               // 三等奖
  NONE: 'NONE'                  // 未获奖
}

// 参赛方向
export const COMPETITION_DIRECTIONS = [
  { value: 'PHYSICS', label: '生命科学', desc: '生命现象与生态' },
  { value: 'CHEMISTRY', label: '物质科学', desc: '物质变化与性质' },
  { value: 'BIOLOGY', label: '宇宙与空间科学', desc: '天体观测与探索' },
  { value: 'ASTRONOMY', label: '技术与工程科学', desc: '技术创新与应用' },
  { value: 'INTERDISCIPLINARY', label: '跨学科领域', desc: '多学科融合创新' }
]

// 年级列表
export const GRADES = [
  { value: '1', label: '一年级' },
  { value: '2', label: '二年级' },
  { value: '3', label: '三年级' },
  { value: '4', label: '四年级' },
  { value: '5', label: '五年级' },
  { value: '6', label: '六年级' },
  { value: '7', label: '七年级' },
  { value: '8', label: '八年级' },
  { value: '9', label: '九年级' },
]

// Token存储key
export const TOKEN_KEY = 'homelab_token'
export const USER_INFO_KEY = 'homelab_user_info'
